module.exports = __webpack_public_path__ + "media/images/konintodoke/printer-03f4c8f0198e73197132da589ed71364.svg";